import { ICreateEntradaMultiPUseCase } from "../../../presentation/useCases/create/create_entrada_produtos_multi_use_case";
import { ICreateEntradaPUseCase } from "../../../presentation/useCases/create/create_entrada_produtos_use_case";
import { EntradaProduto } from "../../models/entrada_produtos_lista";
import { IEstoqueRepository } from "../../repositories/estoque_repository";


export class CreateEntradaMultiPUseCase implements ICreateEntradaMultiPUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async createEntradaMultiP(Data: Date | null, IdCentroCusto: number | null, IdProdutoServico: number[] | null, NroNotaFiscal: string | null, Quantidade: number | null, IdFornecedor: number | null, IdOrdemCompraProduto: number | null, NrNotaFiscal: string | null, IdSessaoMultipla: string | null, ValorUnitario: number | null): Promise<string> {
    
    const response = await this.repository.createEntradaMultiP(Data, IdCentroCusto, IdProdutoServico, NroNotaFiscal, Quantidade, IdFornecedor, IdOrdemCompraProduto, NrNotaFiscal, IdSessaoMultipla, ValorUnitario);
    
    return response.idSessaoMultipla ?? "";

  }
}
